module.exports = __webpack_public_path__ + "img/factset_logo.cf3e5afe.png";